/**
 * Common API Response Interface
 * Framework-agnostic generic response wrapper
 */

export interface ApiResponse<T = any> {
  data: T;
  message?: string;
  success?: boolean;
  error?: string;
  errors?: Record<string, string[]>;
  status?: number;
  code?: string;
}

/**
 * Pagination wrapper for data
 */
export interface PaginatedData<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
  totalPages?: number;
}

/**
 * API Response with paginated data
 * Usage: PaginatedApiResponse<Region> will have data: { items: Region[], total: number, ... }
 */
export interface PaginatedApiResponse<T = any> extends ApiResponse<
  PaginatedData<T>
> {}

/**
 * API Response with array data
 * Usage: ListApiResponse<Region> will have data: Region[]
 */
export interface ListApiResponse<T = any> extends ApiResponse<T[]> {}
